define('app-ProductFloatingBoxRight/settings',[],function () {
    return {
        container: $("#scrollLookup"),
        leftNav: $(".leftNav"),
    };
});
